import { StarFilled } from '@ant-design/icons';
import { useQuery } from '@apollo/client/react';
import { Space, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Statistic from '../Statistic';
import GET_STATS from './queries/GetPersistedAverageRating';

const { Text } = Typography;

const TotalMembers = function () {
  const { partnerId } = useParams();
  const { t } = useTranslation();

  const { data, loading } = useQuery(GET_STATS, {
    variables: { partnerId: partnerId! },
  });

  const averageRating = data?.community?.stats?.averageRating || 0;

  return (
    <Statistic
      loading={loading}
      title={t('chat:::satisfaction')}
      value={averageRating}
      suffix={
        <Space>
          <Text style={{ fontSize: 18 }}>
            /5
            <StarFilled />
          </Text>
        </Space>
      }
      decimals={1}
    />
  );
};

export default TotalMembers;
